import { useState } from "react";
import { mainstore } from "../../store";
import APICom from "../../utils/helpers/APICom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal,Button } from 'react-bootstrap';

export default function PrintManifestCriteria({ selectedRow, selectedDate, showPrintManifestCriteria, setShowPrintManifestCriteria, selectedSettings_HideCostOnSDByFundingSource }) {

    const [loading, setLoading] = useState(false)
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalClassName, setModalClassName] = useState("");
    const [modalBodyHTML, setModalBodyHTML] = useState("");
    const [modalBtnHTML, setModalBtnHTML] = useState([]);
    const [showDynamicModal, setShowDynamicModal] = useState(false);


    const [routeNo, setRouteNo] = useState(selectedRow.Route || "");
    const [allRoutes, setAllRoutes] = useState(false);
    const [reportFormat, setReportFormat] = useState("Route By Stops Sheet");

    const handleViewReport = async () => {
        setLoading(true);

        try {
            let RouteNo = allRoutes ? "-" : routeNo;
            let ddlReportFormat = "2";
            let fsIDsList = "-";
            let iAffiliateID = selectedRow.PrimaryAffiliateID;
    
            if(allRoutes === true)
            {
                RouteNo = "-";
            }

            await ShowPrintManifestReportDynamic(
                RouteNo,
                selectedDate,
                ddlReportFormat,
                fsIDsList,
                iAffiliateID
            );
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
        finally {
            setLoading(false);
        }
       
    };


    const ShowPrintManifestReportDynamic = async (RouteNo, RouteDate, ddlReportFormat, FundingSourceValue, AffiliatesValue) => {
        try {
            const response = await APICom.fetchData(
                "AspDotNetCoreURL",
                `ManifestManagement/GetManifestnAssignedRequestQueue?manifestDate=${encodeURIComponent(RouteDate)}&bWillCall=${true}&affiliateList=${encodeURIComponent(AffiliatesValue)}&fundingSourceList=${encodeURIComponent(FundingSourceValue)}&ddlReportFormat=${encodeURIComponent(ddlReportFormat)}&routeNo=${encodeURIComponent(RouteNo)}&settings_HideCostOnSDByFundingSource=${encodeURIComponent(selectedSettings_HideCostOnSDByFundingSource)}`,
                "get",
                {},
                {}
            );
            if (response && response.error.length === 0) {
                if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                    await GenerateManifestReportForMRM(response.data);
                }
                else if (response.data && response.data.length === 0) {
                    setModalHeaderText("Print Manifest Report");
                    setModalBodyHTML(<p>{"No Data Found, please contact the administrator."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
            }
            else {
                setModalHeaderText("Print Manifest Report");
                setModalBodyHTML(<p>{(response.error.length > 0 ? response.error : "There was an issue with the API, please contact the administrator.")}</p>);
                setModalBtnHTML(
                    <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                        {"OK"}
                    </Button>
                );
                setShowDynamicModal(true);
            }
        }
        catch (err) { console.log(err); setLoading(false); }
    };

    const GenerateManifestReportForMRM = async (dataArr) => {
        try {
            let myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let reportingURL = mainstore.getState().configuration.REACT_APP_MRMS_REPORTING_API + "ShowRouteByStopsSheet";
            let ReportResponse = await APICom.fetchData("full", reportingURL, "post", headersObj, dataArr, null, false, {}, 'blob');
            if (ReportResponse && ReportResponse.error.length === 0) {
                const blob = new Blob([ReportResponse.data], { type: "application/pdf" });
                const pdfUrl = URL.createObjectURL(blob);

                window.open(pdfUrl, '_ShowPrintManifestReportDynamic');
                URL.revokeObjectURL(pdfUrl);
            }
            else {
                setModalHeaderText("Print Manifest Reprot Alert");
                setModalBodyHTML((ReportResponse.error.length > 0 ? ReportResponse.error : "Unable to open report, please contact the administrator."));
                setModalBtnHTML(
                    <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                        {"OK"}
                    </Button>
                );
                setShowDynamicModal(true);
            }
        }
        catch (err) { console.log(err);  setLoading(false);}
    };

    function headersToObject(headers) {
        try {
            let result = {};
            for (let [key, value] of headers.entries()) {
                result[key] = value;
            }
            return result;
        }
        catch (err) { console.log(err); return []; }
    };

    const handleCloseMainDialog = () => {
        if (showPrintManifestCriteria) {
            setShowPrintManifestCriteria(false);
        }
    }

    return (
        <>
    
    {showDynamicModal ?
        <Modal centered backdrop="static" keyboard={true} onHide={() => setShowDynamicModal(false)} show={showDynamicModal} animation={true} dialogClassName={modalClassName}>
            <Modal.Header className='activate_dialog_header_bgcolor user-select-none'>
                <Modal.Title className='text-white'>{modalHeaderText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{modalBodyHTML}</Modal.Body>
            <Modal.Footer>
                {modalBtnHTML}
            </Modal.Footer>
        </Modal>
    : ""}
            <Modal centered backdrop="static" keyboard={true} onHide={handleCloseMainDialog} show={showPrintManifestCriteria} animation={true} dialogClassName={modalClassName}>
                    <Modal.Header className='activate_dialog_header_bgcolor user-select-none'>
                        <Modal.Title className='text-white'>{"Print Manifest Report"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <div>
     
                        <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                            <input
                            type="text"
                            value={routeNo}
                            placeholder="Route#"
                            disabled={allRoutes}
                            onChange={(e) => setRouteNo(e.target.value)}
                            style={{ flex: 1, marginRight: "8px", padding: "4px" }}
                            />
                            <label>
                                <input
                                    type="checkbox"
                                    checked={allRoutes}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setAllRoutes(checked);
                                        if (checked)
                                        {
                                            //setRouteNo("-");
                                        } 
                                    }}
                                />
                            {" All Routes"}
                            </label>
                        </div>

                        {/* <div
                            style={{display: "inline-flex", justifyContent: "center", alignItems: "center",gap: "10px"}}>
                            <label>Report Format:</label>
                            <input
                                type="text"
                                value={reportFormat}
                                placeholder="Report Format"
                                onChange={(e) => setReportFormat(e.target.value)}
                                style={{ flex: 1, marginRight: "8px", padding: "4px" }}/>
                        </div> */}
                    </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={handleCloseMainDialog} style={{ padding: "6px 12px" }}>
                            Close
                        </button>
                        <button onClick={handleViewReport}
                                style={{ padding: "6px 12px", minWidth: "120px" }}
                                disabled={loading} >
                                    {loading ? (
                                    <span>
                                        <span className="spinner-border spinner-border-sm" role="status" />
                                        {" "}Processing...
                                    </span>
                                    ) : (
                                    "View Report"
                                )}
                        </button>
                    </Modal.Footer>
                </Modal>
        </>
  );
}

    

